export default __webpack_public_path__ + "static/media/icon_folder_active.0cef2374.svg";